export default __webpack_public_path__ + "static/media/guide_step_m.4e50037b.png";